/*
 * <countdown-timer> — ticking urgency countdown.
 *
 * data-mode="daily": counts down to data-cutoff ("HH:MM") each day; once the
 *   cutoff passes it rolls to the next day's cutoff.
 * data-mode="date": counts down to data-end ("YYYY-MM-DD HH:MM" or ISO); when
 *   reached it shows the expired text (or 00:00:00) and stops.
 * Times are interpreted in the visitor's local timezone.
 */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('countdown-timer')) {
    return;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      this.timeEl = this.querySelector('[data-cd-time]');
      if (!this.timeEl) return;

      this.mode = this.dataset.mode === 'date' ? 'date' : 'daily';
      this.showDays = this.dataset.showDays === 'true';
      this.cutoff = this.dataset.cutoff || '15:00';
      this.end = this.dataset.end || '';
      this.expiredText = this.dataset.expiredText || '';

      this._tick = this._tick.bind(this);
      this._tick();
      this.timer = window.setInterval(this._tick, 1000);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    _target(now) {
      if (this.mode === 'date') {
        if (!this.end) return null;
        var d = new Date(this.end.trim().replace(' ', 'T'));
        return isNaN(d.getTime()) ? null : d;
      }
      var parts = String(this.cutoff).split(':');
      var h = parseInt(parts[0], 10) || 0;
      var m = parseInt(parts[1], 10) || 0;
      var c = new Date(now);
      c.setHours(h, m, 0, 0);
      if (c.getTime() <= now.getTime()) {
        c.setDate(c.getDate() + 1);
      }
      return c;
    }

    _tick() {
      var now = new Date();
      var target = this._target(now);

      if (!target) {
        this.timeEl.textContent = '--:--:--';
        return;
      }

      var diff = Math.floor((target.getTime() - now.getTime()) / 1000);

      if (this.mode === 'date' && diff <= 0) {
        this.classList.add('cd--expired');
        if (this.expiredText) {
          this.textContent = this.expiredText;
        } else {
          this.timeEl.textContent = '00:00:00';
        }
        if (this.timer) window.clearInterval(this.timer);
        return;
      }

      if (diff < 0) diff = 0;

      var days = Math.floor(diff / 86400);
      var hours = Math.floor((diff % 86400) / 3600);
      var mins = Math.floor((diff % 3600) / 60);
      var secs = diff % 60;

      var out;
      if (this.mode === 'date' && this.showDays && days > 0) {
        out = days + 'd ' + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
      } else {
        var hh = this.mode === 'date' ? days * 24 + hours : hours;
        out = pad(hh) + ':' + pad(mins) + ':' + pad(secs);
      }
      this.timeEl.textContent = out;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
})();
